export default __webpack_public_path__ + "static/media/Demographics.8f1d5b6c.svg";